import { all, call, put, select, take, takeEvery } from "redux-saga/effects";

import { ToastContent, getToastContent } from "constants/toasts";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { pushWithUTM } from "helpers/sagas";
import { AgentsRoutes } from "routes/agents/constants";
import { CRUDAction, RequestAction } from "store/entities/actions";
import { LICENSE, LicenseActions } from "store/entities/license";
import { ITeam, TEAM, TeamActions, selectTeam } from "store/entities/teams";
import { ToastVariant, ToastsActions } from "store/features/toasts";
import { IActionWithPayload } from "store/helper";

import { TeamsViewActionsNames } from "./actions";
import {
  ITeamCreatePayload,
  ITeamCreateSuccessPayload,
  ITeamDeletePayload,
  ITeamUpdatePayload,
  ITeamUpdateSuccessPayload,
} from "./interfaces";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* createTeam(action: IActionWithPayload<string, ITeamCreatePayload>) {
  const payload = { ...action.payload };
  yield put(TeamActions.create({ value: payload }));
  yield call(trackEngagement, "Teams: Team created", EventPlace.Agents);
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* createTeamSuccess(action: IActionWithPayload<string, ITeamCreateSuccessPayload>) {
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.TEAM_CREATE_SUCCESS),
      variant: ToastVariant.Success,
    })
  );

  const teamId = action.payload.id;
  yield put(pushWithUTM(`/agents/teams/${teamId}`));
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* createTeamFailure() {
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.TEAM_CREATE_FAILURE),
      variant: ToastVariant.Error,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* updateTeam(action: IActionWithPayload<string, ITeamUpdatePayload>) {
  const payload = { ...action.payload };

  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const currentTeam: ITeam = yield select(selectTeam, payload.id);

  if (!currentTeam.isDefault && payload.isDefault) {
    // @ts-expect-error TS(2322)
    yield put(LicenseActions.updateDefaultTeam({ defaultTeamId: payload.id }));
    yield take([
      LICENSE.UPDATE_DEFAULT_TEAM[RequestAction.SUCCESS],
      LICENSE.UPDATE_DEFAULT_TEAM[RequestAction.FAILURE],
    ]);
  }

  yield put(TeamActions.update({ value: payload }));
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* updateTeamSuccess(action: IActionWithPayload<string, ITeamUpdateSuccessPayload>) {
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.TEAM_UPDATE_SUCCESS),
      variant: ToastVariant.Success,
    })
  );

  const teamId = action.payload.id;
  yield put(pushWithUTM(`/agents/teams/${teamId}`));
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* deleteTeam(action: IActionWithPayload<string, ITeamDeletePayload>) {
  const payload = { ...action.payload };
  yield put(TeamActions.delete({ id: payload.teamId }));
  yield call(trackEngagement, "Teams: Team deleted", EventPlace.Agents);
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* deleteTeamSuccess() {
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.TEAM_DELETE_SUCCESS),
      variant: ToastVariant.Success,
    })
  );

  yield put(pushWithUTM(AgentsRoutes.Teams));
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* deleteTeamFailure() {
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.TEAM_DELETE_FAILURE),
      variant: ToastVariant.Error,
    })
  );

  yield put(pushWithUTM(AgentsRoutes.Teams));
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* teamsViewSagas() {
  yield all([
    takeEvery(TeamsViewActionsNames.CREATE_TEAM, createTeam),
    takeEvery(TEAM[CRUDAction.CREATE][RequestAction.SUCCESS], createTeamSuccess),
    takeEvery(TEAM[CRUDAction.CREATE][RequestAction.FAILURE], createTeamFailure),
    takeEvery(TeamsViewActionsNames.UPDATE_TEAM, updateTeam),
    takeEvery(TEAM[CRUDAction.UPDATE][RequestAction.SUCCESS], updateTeamSuccess),
    takeEvery(TeamsViewActionsNames.DELETE_TEAM, deleteTeam),
    takeEvery(TEAM[CRUDAction.DELETE][RequestAction.SUCCESS], deleteTeamSuccess),
    takeEvery(TEAM[CRUDAction.DELETE][RequestAction.FAILURE], deleteTeamFailure),
  ]);
}
